import BaseModule from './../../../../modules/Base.module';
import PasswordMeterController from './controller/PasswordMeter.controller';

/**
 * @extends {BaseModule}
 */
class PasswordMeterModule extends BaseModule {

	constructor ( config ) {

		super( config );
	}

	init () {
		super.init();

		const controllerInstance = new PasswordMeterController();

		this.passwordMeter = controllerInstance.init( this.node );
	}
}

export default PasswordMeterModule;



// WEBPACK FOOTER //
// ./js/forms/v2/modules/passwordMeter/PasswordMeter.module.js